"use client";

import { requestChartSymbol } from "@/lib/chart/chartSymbolRequest";
import { setScopeSymbol } from "@/lib/stores/symbolStore";
import { scopeForPath } from "@/lib/stock/briefReturn";

/** Write `symbol` into the page scope that owns `pathname` and ask that
 *  page's Advanced Chart to follow. No-op when the path has no scope. */
export function applyPathSymbol(pathname: string, symbol: string): void {
  const scope = scopeForPath(pathname);
  const sym = (symbol || "").trim().toUpperCase().replace(/\.US$/i, "");
  if (!scope || !sym) return;
  setScopeSymbol(scope, sym);
  requestChartSymbol(sym, scope);
}
